import { useState } from "react";
import { Button, Modal, Textarea, Text, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFileImport } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

export default function JsonSchemaImport({ onImport }) {
  const [opened, { open, close }] = useDisclosure(false);
  const [schemaText, setSchemaText] = useState("");

  const handleImport = () => {
    try {
      const schema = JSON.parse(schemaText);
      const properties = schema.properties || {};
      const required = schema.required || [];

      const params = Object.entries(properties).map(([name, prop]) => ({
        name,
        description: prop.description || "",
        type: prop.type === "number" || prop.type === "integer" ? "number" : "string",
        required: required.includes(name),
        isList: prop.type === "array",
      }));

      if (params.length === 0) {
        notifications.show({
          title: "No properties found",
          message: "The JSON Schema did not contain any properties to import.",
          color: "yellow",
        });
        return;
      }

      onImport(params);
      notifications.show({
        title: "Imported",
        message: `${params.length} parameter(s) imported from JSON Schema`,
        color: "green",
      });
      setSchemaText("");
      close();
    } catch (e) {
      notifications.show({
        title: "Invalid JSON",
        message: e.message,
        color: "red",
      });
    }
  };

  return (
    <>
      <Button
        variant="subtle"
        size="compact-sm"
        leftSection={<IconFileImport size={14} />}
        onClick={open}
      >
        Import JSON Schema
      </Button>

      <Modal opened={opened} onClose={close} title="Import JSON Schema">
        <Stack>
          <Text size="sm" c="dimmed">
            Paste a standard JSON Schema object with &quot;properties&quot; and
            optional &quot;required&quot; array. Parameters will be created from
            the schema properties.
          </Text>
          <Textarea
            placeholder={`{
  "type": "object",
  "properties": {
    "query": { "type": "string", "description": "Search query" },
    "limit": { "type": "number", "description": "Max results" }
  },
  "required": ["query"]
}`}
            autosize
            minRows={6}
            maxRows={15}
            value={schemaText}
            onChange={(e) => setSchemaText(e.currentTarget.value)}
          />
          <Button onClick={handleImport} disabled={!schemaText.trim()}>
            Import
          </Button>
        </Stack>
      </Modal>
    </>
  );
}
